var _preventedKeys;

import * as keyCodes from '../../key-codes';

var preventedKeys = (_preventedKeys = {}, _preventedKeys[keyCodes.enter] = true, _preventedKeys[keyCodes.tab] = true, _preventedKeys);

export default (function (event) {
  if (preventedKeys[event.keyCode]) {
    event.preventDefault();
  }
});


//////////////////
// WEBPACK FOOTER
// ./~/react-beautiful-dnd/esm/view/drag-handle/util/prevent-standard-key-events.js
// module id = 652
// module chunks = 0